import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Badge, Space } from 'antd-mobile'
import { connect } from 'react-redux'
const footerList = [
	{
		name: "首页",
		icon1: "icon-shouye-xianxing",
		icon2: "icon-shouye",
		url: "/"
	},
	/*
	{
		name: "分类",
		icon1: "icon-yingyongchengxu-xianxing",
		icon2: "icon-yingyongchengxu",
		url: "/category"
	},
	*/
	{
		name: "购物车",
		icon1: "icon-caigou-xianxing",
		icon2: "icon-caigou",
		url: "/cart"
	},
	{
		name: "订单",
			icon1: "icon-yingyongchengxu-xianxing",
		icon2: "icon-yingyongchengxu",
		url: "/order/list/0"
	},
	{
		name: "报修",
		icon1: "icon-yonghu-xianxing",
		icon2: "icon-yonghu",
		url: "/repair/list/0"
	}
]
class Tab extends Component {
	changeIndex(item) {
		this.props.history.push(item.url)
	}

	render() {
		const location = this.props.location
		let showTab = false
		footerList.forEach((item, index) => {
			if (item.url === location.pathname) {
				//showTab = true
				showTab = false
			}
		})

		return (
			showTab ? <div id="footer" className="acea-row row-around">
				{
					footerList.map((item, index) => {
						return (
						index==1 ? (
						<Badge
            color='#87d068'
            content={this.props.cate_qty !=0 ? this.props.cate_qty : ''}
            style={{ '--right': '100%' }}
          >
						 <Badge content={this.props.item_qty!=0 ? this.props.item_qty : '' }>
							<div

								className={`item ${item.url === location.pathname ? 'on' : ''}`}
								key={index}
								onClick={this.changeIndex.bind(this, item)}
							>
								<div
									className={`iconfont ${item.icon1} ${item.url === location.pathname ? item.icon2 : ''}`}
								></div>
								<div>{item.name}</div>
							</div>
							</Badge>
							</Badge>
							) :(index==3 ?
							(<Badge
            color='#87d068'
            content={this.props.process_qty !=0 ? this.props.process_qty : ''}
            style={{ '--right': '100%' }}
          >
						 <Badge content={this.props.req_qty!=0 ? this.props.req_qty : '' }>
							<div

								className={`item ${item.url === location.pathname ? 'on' : ''}`}
								key={index}
								onClick={this.changeIndex.bind(this, item)}
							>
								<div
									className={`iconfont ${item.icon1} ${item.url === location.pathname ? item.icon2 : ''}`}
								></div>
								<div>{item.name}</div>
							</div>
							</Badge>
							</Badge>)

							: (
							    <div

								className={`item ${item.url === location.pathname ? 'on' : ''}`}
								key={index}
								onClick={this.changeIndex.bind(this, item)}
							>
								<div
									className={`iconfont ${item.icon1} ${item.url === location.pathname ? item.icon2 : ''}`}
								></div>
								<div>{item.name}</div>
							</div>
							) )
						)
					})
				}
			</div >
				: null

		)
	}
}
const mapStateToProps = (state) => {
  return {
    cate_qty: state.app.cate_qty,
    item_qty: state.app.item_qty,
    process_qty:state.app.process_qty,
    req_qty:state.app.req_qty
  }
}
Tab = connect(mapStateToProps)(Tab)
export default withRouter(Tab)
